import { render, staticRenderFns } from "./directory-item.vue?vue&type=template&id=c73f524e&scoped=true"
import script from "./directory-item.vue?vue&type=script&lang=js"
export * from "./directory-item.vue?vue&type=script&lang=js"
import style0 from "./directory-item.vue?vue&type=style&index=0&id=c73f524e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73f524e",
  null
  
)

export default component.exports